<div class="modal-header">
    <h3 class="modal-title">Reject Timecard</h3>
</div>
<div class="modal-body">
    <div *ngIf="rejectReasons?.length != 0">
        <label>Rejection Reason</label>
        <ng-select [(ngModel)]="formData.Reason"
                   [items]="rejectReasons"
                   bindLabel="DisplayValue"
                   bindValue="DatabaseValue">
        </ng-select>
            <label>Rejection Notes</label>
            <input type="text" class="form-control"
                   [(ngModel)]="formData.Notes" />
    </div>
    <div *ngIf="rejectReasons.length == 0">
        There are no reason codes to select. Contact your administrator for assistance.
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" *ngIf="rejectReasons.length != 0" [disabled]="formData.Reason == null || formData.Notes == null" (click)="rejectClicked()">Reject</button>
    <button type="button" class="btn btn-default" (click)="cancelClicked()">Cancel</button>
</div>